// defectiveReturnSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// Async thunk to get paginated defective returns
export const get_defective_returns = createAsyncThunk(
  "defectiveReturns/get",
  async (data) => {
    const body = new FormData();
    body.append("action", "list");
    
    if (data.page) body.append("page", data.page);  
    if (data.limit) body.append("limit", data.limit);

    const response = await fetch( baseUrl + "defective_return.php",
      {
        method: "POST",
        body: body,
      }
    );

    const res = await response.json();
    return res;
  }
);

// Add this after get_defective_returns thunk
export const get_defective_return_detail = createAsyncThunk(
  "defectiveReturns/getDetail",
  async (data) => {
    const body = new FormData();
    body.append("action", "list_by_id");
    body.append("id", data.id);
    body.append("type", data.type || "2");

    const response = await fetch(baseUrl + "defective_return.php", {
      method: "POST",
      body: body,
    });

    const res = await response.json();
    return res;
  }
);



const initialState = {
  defective_returns: [],
  defective_return_detail: null,  // Add this
  detail_loading: false,           // Add this
  loading: false,
  total_count: 0,
  count: 0,
};

const defectiveReturnSlice = createSlice({
  name: "defectiveReturns",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_defective_returns.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_defective_returns.rejected, (state) => {
        state.loading = false;
        state.defective_returns = [];
        state.total_count = 0;
        state.count = 0;
      })
      .addCase(get_defective_returns.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          state.defective_returns = data.data || [];
          state.total_count = parseInt(data.totalcount) || 0;
          state.count = parseInt(data.count) || 0;
        } else {
          state.defective_returns = [];
          state.total_count = 0;
          state.count = 0;
        }
      })
      // Add these cases in extraReducers builder
.addCase(get_defective_return_detail.pending, (state) => {
  state.detail_loading = true;
})
.addCase(get_defective_return_detail.rejected, (state) => {
  state.detail_loading = false;
  state.defective_return_detail = null;
})
.addCase(get_defective_return_detail.fulfilled, (state, action) => {
  state.detail_loading = false;
  const data = action.payload;
  if (data.success) {
    state.defective_return_detail = data.data || null;
  } else {
    state.defective_return_detail = null;
  }
});

  },
});

export default defectiveReturnSlice.reducer;